import React from 'react';
import { required, SelectInput, DateField, Toolbar, SaveButton, Filter, Create, Edit, List, Datagrid, FunctionField, 
  TextField, TextInput, BooleanInput, TabbedForm, FormTab, ArrayField, SelectArrayInput, FormDataConsumer, 
  ReferenceArrayInput, AutocompleteArrayInput, downloadCSV, useListContext, TopToolbar, sanitizeListRestProps, 
  FilterButton, CreateButton, ExportButton, NumberField, EditButton } from 'react-admin';
import jsonExport from 'jsonexport/dist';
import { CustomDateField } from './components/utils';
const utils = require('./components/utils');
const {EXCLUDED_BIDDERS_LIST, AdstxtListStatus, CrawlButton, MissingAdstxtButton, BidderStatus, AdstxtIPWhiteList} = require('./components/adstxt_status');
const {AUDIT_STATUS, AuditStatusDetail, AuditListStatus, AuditStatusSummary, AuditStatus, BlockedButton, RejectedButton} = require('./components/audit_status');


let globalRole = 'publisher';

const exporter = sites => {
  const sitesForExport = sites.map(site => {
    let bidderAuditStatus = [];
    let bidderAdstxtStatus = [];
    if (site.bidder_audit_status) for (const key of Object.keys(site.bidder_audit_status)) {
      const message = site.bidder_audit_status[key].message ? ` (${site.bidder_audit_status[key].message})` : '';
      bidderAuditStatus.push(`${key} ${site.bidder_audit_status[key].status}${message}`);
    }
    if (site.adstxt_results && site.adstxt_results.bidder_results) for (const bidderStatus of site.adstxt_results.bidder_results) {
      if (bidderStatus.match && bidderStatus.match.length>0) bidderAdstxtStatus.push(`"${bidderStatus.bidder_id} ${bidderStatus.match.join('/')}"`)
    }
    let o = {
        id: site.code,
        name: site.name,
        type: site.type,
        audit_status: bidderAuditStatus.join('|'),
        adstxt_status: bidderAdstxtStatus.join('|')
    };
    if (globalRole === 'admin') {
      o.wtd_impressions = site.revenue_stats && site.revenue_stats.total_impressions ? site.revenue_stats.total_impressions : 0;
      o.wtd_revenue = site.revenue_stats && site.revenue_stats.total_revenue ? site.revenue_stats.total_revenue : 0;
      o.wtd_ad_requests = site.revenue_stats && site.revenue_stats.total_ad_requests ? site.revenue_stats.total_ad_requests : 0;
    }
    return o;
  });
  let headers = ['id', 'name', 'type', 'audit_status', 'audit_reason'];
  if (globalRole === 'admin') {
    headers = headers.concat(['wtd_impressions', 'wtd_revenue', 'wtd_ad_requests']);
  }
  jsonExport(sitesForExport, {
      headers: headers
  }, (err, csv) => {
      downloadCSV(csv, 'sites');
  });
};
const DomainTitle = ({ record }) => {
  return [<div>
      Domain {record ? `"${record.name}"` : ''}
      {record && record.adstxt_results && !record.adstxt_results.status ? <MissingAdstxtButton /> : ''}
      {record && record.blocked ? <BlockedButton /> : ''}
      {record && record.audit_status==='rejected' ? <RejectedButton />: ''}
  </div>]
};
const domainFilters = [
  <TextInput label="Search" source="search_name" alwaysOn resettable />,
  <SelectArrayInput source="type" choices={utils.SITE_TYPES} label="Type" resettable />,
  <SelectArrayInput source="audit_status" choices={AUDIT_STATUS} label="Audit Status" resettable style={{width: '200px'}}/>,
  <ReferenceArrayInput source="bidder_id" label="Bidders" style={{ width: '250px' }}
    allowEmpty={false}
    reference="bidders"
    basePath='Bidders'
    perPage={10}
    sort={{ field: 'name', order: 'ASC' }}
    filterToQuery={searchText => ({ search_name: searchText, adstxt_config: true })}>
    <AutocompleteArrayInput label="Bidders" optionValue="code" style={{ width: '250px' }}
        optionText={record => (record && record.name)?`${record.name} (${record.code})`:''}  />
  </ReferenceArrayInput>,
  <BooleanInput source="adstxt_file_found" defaultValue={true} label="Adstxt File Found" resettable />,
  <BooleanInput source="adstxt_bidder_found" defaultValue={true} label="Adstxt Bidder Found" resettable />,
  <BooleanInput source="blocked" defaultValue='true' label="Blocked" resettable />,
];
const CustomToolbar = props => (
	<Toolbar {...props}>
		<SaveButton />
		<br />
		<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
		<TextField source="updated_name" label="" style={{ padding: '10px' }} />
	</Toolbar>
);
const ListActions = (props) => {
  const { className, maxResults, ...rest } = props;
  const { total } = useListContext();
  return (
      <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
          <FilterButton />
          <CreateButton />
          <ExportButton disabled={total === 0} maxResults={13000} exporter={exporter}/>
      </TopToolbar>
  );
};
export const DomainList = ({ permissions, ...props }) => (
  globalRole = (permissions) ? permissions.role : 'publisher',
	<List {...props} title="Domains" 
  perPage={25} 
  bulkActionButtons={false} 
  filters={domainFilters} 
  actions={<ListActions />}>
		<Datagrid rowClick="edit">
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
      <TextField source="type" label="Type" />
      {permissions && permissions.role === 'admin' &&
          [
          <NumberField source="revenue_stats.total_impressions" label="WTD Impressions" />,
          <NumberField source="revenue_stats.total_revenue" label="WTD Revenue" options={{ style: 'currency', currency: 'USD' }} />,
          <NumberField source="revenue_stats.total_ad_requests" label="WTD Requests" />,
          ]
      }
      <AuditListStatus {...props} label="Audit"/>
      <AdstxtListStatus {...props} label="Adstxt"/>
      <EditButton variant="contained" color="primary" />
		</Datagrid>
	</List>
);
class DomainForm extends React.Component {
  getAdstxtCoverageRate = function (record) {
    let total = 0;
    if (record && record.adstxt_results && record.adstxt_results.bidder_results) {
      total = record.adstxt_results.bidder_results.length;
      if (total > 0) {
        const positive = record.adstxt_results.bidder_results.filter(x=> x.status).length;
        return 100 * Number(positive) / Number(total);
      }
    }
    return 0;
  }
  render (props) {
    if (this.props.record && this.props.record && this.props.record.adstxt_results && this.props.record.adstxt_results.bidder_results) {
      this.props.record.adstxt_results.bidder_results = this.props.record.adstxt_results.bidder_results.filter(x => !EXCLUDED_BIDDERS_LIST.includes(x.bidder_id));
      this.props.record.adstxt_results.bidder_results.sort( (x, y) => (x.bidder_name>y.bidder_name) ? 1 : -1 );
    }
    this.props.record.bidder_audit_status_list = this.props.record.bidder_audit_status ? Object.keys(this.props.record.bidder_audit_status).map(id=> {return {bidder_id:id, ...this.props.record.bidder_audit_status[id]} }) : [];
    this.props.record.bidder_audit_status_list.sort( (x, y) => (x.bidder_name>y.bidder_name) ? 1 : -1 );
    this.adstxtCoverageRate = this.getAdstxtCoverageRate(this.props.record);
    const permissions = this.props.permissions;
    return (
      <TabbedForm toolbar={<CustomToolbar />} {...this.props}>
        <FormTab label="Domain Settings">
          <AuditStatusSummary {...this.props}/>
          <br/>
          <TextField source="code" label="Domain ID" />
          <TextInput source="name" label="Domain name" style={{ width: '400px' }} validate={required()} />
          <SelectInput source="type" label="Type" choices={utils.SITE_TYPES} validate={required()} />
          <BooleanInput source="blocked" label="Block this domain" />
          <TextInput source="adstxt_domain" label="Ads.txt file location" style={{ width: '400px' }} />
          <BooleanInput source="adstxt_cachebuster_disabled" label="Disable cache buster" style={{ width: '300px' }} />
          <BooleanInput source="adstxt_html_tag_enabled" label="Enable <HTML> tag in ads.txt file" style={{ width: '300px' }} />
          <TextInput source="adstxt_ua" label="Ads.txt file crawler User-Agent" style={{ width: '400px' }} />
          <DateField source="last_crawl" label="Last ads.txt crawl date" />
          <TextField source="last_crawl_appn" label="Last audit date" />
        </FormTab>
        {this.props.formType==='edit' &&
        <FormTab label="Ads.txt">
          <div style={{fontSize: 'normal', marginBottom: '10px'}}>AdsTxt Status</div>
          <FormDataConsumer>
          {({ formData }) => formData && formData.adstxt_results && !formData.adstxt_results.status && 
              [<MissingAdstxtButton />,<br/>,<br/>]
          }
          </FormDataConsumer>
          <CrawlButton />
          <br/>
          <BooleanInput source="adstxt_crawl_skip" label="Disable Ads.txt Crawling" style={{ width: '250px' }} />
          <span>Adstxt Coverage Rate: {this.adstxtCoverageRate.toFixed(0)}%</span>
          <ArrayField source="adstxt_results.bidder_results" label="Ads.txt Status">
              <Datagrid style={{ width: '100%' }}>
                  {permissions && ['admin'].includes(permissions.role) && 
                  <FunctionField label="Bidder" render={record => `${record.bidder_name} (${record.bidder_id})`} 
                  style={{ whiteSpace: 'nowrap' }}/>
                  }
                  {permissions && !['admin'].includes(permissions.role) && 
                  <TextField label="Bidder" source="bidder_name" style={{ whiteSpace: 'nowrap' }}/>
                  }
                  <BidderStatus label="Ads.txt Status"/>
                  <AuditStatus label="Audit Status" parent={this.props.record}/>
              </Datagrid>
          </ArrayField>
          <TextField source="last_crawl" label="Last Adxtxt Crawl Time" />
          <AdstxtIPWhiteList />
        </FormTab>
        }
        {this.props.formType==='edit' &&
        <FormTab label="Audit">
          <AuditStatusDetail label="Audit Status" {...permissions}/>
        </FormTab>
        }

          <FormTab label="Revenue Summary">
            <NumberField source="revenue_stats.total_impressions" label="Week To Date Impressions" />
            <NumberField source="revenue_stats.total_revenue" label="Week To Date Revenue ($)" options={{ style: 'currency', currency: 'USD' }} />
            <NumberField source="revenue_stats.total_ad_requests" label="Week To Date Ad Requests" />

            <ArrayField source="revenue_stats.daily">
                <Datagrid>
                    <CustomDateField label="Date" />
                    <NumberField source="impressions" label="Impressions" />
                    <NumberField source="revenue" label="Revenue" options={{ style: 'currency', currency: 'USD' }} />
                    <NumberField source="avg_cpm" label="CPM" options={{ style: 'currency', currency: 'USD' }} />
                    <NumberField source="ad_requests" label="Ad_Requests" />
                    <FunctionField render={record => record.fill_rate ? utils.formatDouble(record.fill_rate*100, '%') : ''} label="%Fill_Rate" />
                </Datagrid>
            </ArrayField>
        </FormTab>
      </TabbedForm>
    );
  }
}
export const DomainEdit = ({ permissions, ...props }) => {
  return (
    <Edit title={<DomainTitle />} {...props}>
      <DomainForm formType="edit" permissions={permissions} {...props}/>
    </Edit>
  )
}
export const DomainCreate = ({ permissions, ...props }) => {
  return (
    <Create title={<DomainTitle />}  {...props}>
      <DomainForm formType="create" permissions={permissions} {...props}/>
    </Create>
  )
}